import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ImageSlider.css";

const API_URL =
  "https://kkblossomschool.org/KKBlossomsWebsite/api.php?action=getImages&category=slider";
const IMAGE_PATH = "https://kkblossomschool.org/KKBlossomsWebsite/uploads/";

const ImageSlider = () => {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        setLoading(true);

        const response = await axios.get(API_URL);

        console.log("API Response:", response.data);

        // Works with both old and new API formats
        const imageData = Array.isArray(response.data)
          ? response.data
          : response.data.data || [];

        const sliderImages = imageData.map(
          (img) => `${IMAGE_PATH}${img.image}`
        );

        // Wait until every image is loaded
        await Promise.all(
          sliderImages.map(
            (src) =>
              new Promise((resolve) => {
                const image = new Image();
                image.src = src;
                image.onload = resolve;
                image.onerror = resolve;
              })
          )
        );

        setImages(sliderImages);
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  if (loading) {
    return (
      <div className="awards-loader-wrapper">
        <svg
          role="img"
          aria-label="Loading"
          className="awards-smiley"
          viewBox="0 0 128 128"
        >
          <defs>
            <clipPath id="awards-smiley-eyes">
              <circle
                className="awards-smiley__eye1"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(-40,64,64) translate(0,-56)"
              />
              <circle
                className="awards-smiley__eye2"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(40,64,64) translate(0,-56)"
              />
            </clipPath>

            <linearGradient
              id="awards-smiley-grad"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#000" />
              <stop offset="100%" stopColor="#fff" />
            </linearGradient>

            <mask id="awards-smiley-mask">
              <rect
                x="0"
                y="0"
                width="128"
                height="128"
                fill="url(#awards-smiley-grad)"
              />
            </mask>
          </defs>

          <g
            strokeLinecap="round"
            strokeWidth="12"
            strokeDasharray="175.93 351.86"
          >
            <g>
              <rect
                fill="hsl(207,90%,50%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(198,83%,60%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>

            <g mask="url(#awards-smiley-mask)">
              <rect
                fill="hsl(205,86%,62%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(197,94%,63%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="slider-container">
        <p>No images found.</p>
      </div>
    );
  }

  return (
    <div className="slider-container">
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`slide-${index}`}
          className={`slider-image ${
            index === currentIndex ? "active" : ""
          }`}
        />
      ))}
    </div>
  );
};

export default ImageSlider;